/// <amd-module name="TFS/Admin/Groups/Pivots/Permissions/Redux/PermissionsPivotSelectors" />
import { PermissionTrace, SubjectPermission, SubjectPermissions } from "TFS/Admin/Common/Contracts/OrganizationSettings";
import { IPermissionsPivotAwareState, SelectedPermissionChangeStatus } from "TFS/Admin/Groups/Common/Contracts";
import { MessageCardSeverity } from "VSSUI/MessageCard";

export function getSubjectPermissions(state: IPermissionsPivotAwareState): SubjectPermissions | undefined {
    if (!state || !state.permissions || !state.permissions.data) {
        return undefined;
    }

    return state.permissions.data.permissions;
}

export function getMessageCardText(state: IPermissionsPivotAwareState): string | undefined {
    if (!state || !state.permissions) {
        return undefined;
    }

    return state.permissions.messageCardText;
}

export function getMessageCardSeverity(state: IPermissionsPivotAwareState): MessageCardSeverity | undefined {
    if (!state || !state.permissions) {
        return undefined;
    }

    return state.permissions.messageCardSeverity;
}

export function getPermissionTraces(state: IPermissionsPivotAwareState): { [id: string]: PermissionTrace } {
    if (!state || !state.permissions || !state.permissions.data) {
        return {};
    }

    return state.permissions.data.permissionTraces || {};
}

export function getSelectedPermission(state: IPermissionsPivotAwareState): SubjectPermission | undefined {
    if (!state || !state.permissions || !state.permissions.data) {
        return undefined;
    }

    return state.permissions.data.selectedPermission;
}

export function getLoading(state: IPermissionsPivotAwareState): boolean {
    if (!state || !state.permissions) {
        return true;
    }

    return state.permissions.loading;
}

export function getSelectedPermissionChangeStatus(state: IPermissionsPivotAwareState): SelectedPermissionChangeStatus {
    if (!state || !state.permissions || !state.permissions.data) {
        return {};
    }

    return state.permissions.data.selectedPermissionChangeStatus;
}

export function isProjectScope(state: IPermissionsPivotAwareState): boolean {
    if (!state || !state.permissions) {
        return false;
    }

    return state.permissions.isProjectScope;
}
